import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  errorMessage: "",
  customPrice: 0,
};

const name = "APP";

const appSlice = createSlice({
  name,
  initialState,
  reducers: {
    setErrorMessage(state, { payload }) {
      state.errorMessage = payload;
    },
    setCustomPrice(state, { payload }) {
      state.customPrice = payload;
    },
  },
});

export const { setErrorMessage, setCustomPrice } = appSlice.actions;

export const selectCustomPriceState = (state: any) => state.app.customPrice;

export default appSlice.reducer;
